// Fix for ipad/iphone based on: http://www.danwellman.co.uk/fixing-jquery-click-events-for-the-ipad/
var ua = navigator.userAgent;
var Ios_Click = (ua.match(/(iPad|iPhone)/i)) ? "click" : "click";